import { Typography } from '@mui/material';
import { cn } from '../../../../../components/utils';
import { useTranslation } from 'react-i18next';

type WorkoutEventItemProps = {
  title: string;
  primaryColor: string;
  backgroundColor: string;
  onClick?: () => void;
  /**
   * The event's date, pre-formatted for the accessible name — each workout
   * exposes its date even when only the title is visible (SC-5441).
   */
  accessibleDate?: string;
  /** Saving state while a drag move for this workout is in flight. */
  isMoving?: boolean;
};

export function WorkoutEventItem({
  title,
  primaryColor,
  backgroundColor,
  onClick,
  accessibleDate,
  isMoving,
}: WorkoutEventItemProps) {
  const { t } = useTranslation();
  const clickable = typeof onClick === 'function';
  // Event rows must stay a consistent height for FullCalendar dayMaxEventRows layout.
  return (
    <button
      type="button"
      className={cn(
        'flex items-center w-full h-6 rounded-sm overflow-hidden text-left p-0',
        clickable ? 'cursor-pointer hover:opacity-80' : 'cursor-default',
        isMoving && 'opacity-50',
      )}
      style={{ backgroundColor }}
      onClick={onClick}
      disabled={!clickable}
      aria-busy={isMoving || undefined}
      aria-label={
        accessibleDate
          ? t('workoutOnDate', { name: title, date: accessibleDate })
          : undefined
      }
    >
      <div
        className="w-[3px] self-stretch shrink-0"
        style={{ backgroundColor: primaryColor }}
      />

      <div className="flex-1 min-w-0 px-1 py-1 shrink-0 flex items-center">
        <Typography
          variant="caption"
          className="truncate leading-4 pl-2"
          color="text.primary"
        >
          {title}
        </Typography>
      </div>
    </button>
  );
}
